import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { fieldsPrefixForDF } from 'drapcode-constant';
import EditDerivedField from './EditDerivedField';
import {
  labelForFunctionMethod,
  snakeCaseToTitleCase,
  expressionToString,
} from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import showAlert from '../../../../common/utils/alert';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';
import { TABLE_FORMAT } from '../../../../common/custom';

export default class DerivedFieldDetail extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    utility: PropTypes.object.isRequired,
  };
  state = {
    isEditUtility: false,
  };

  enableUpdateUtility = () => {
    this.setState({ isEditUtility: true });
  };

  disableUpdateUtility = () => {
    this.setState({ isEditUtility: false });
  };

  updateUtility = (finalUtilityObj) => {
    this.disableUpdateUtility();
  };

  getFieldNameFromConstant = (fieldName) => {
    if (fieldName.includes('current_user.'))
      return `Current User: ${fieldName.replace('current_user.', '')}`;
    if (fieldName.includes('current_user_reference_field.'))
      return `Current User Reference Field: ${fieldName.replace(
        'current_user_reference_field.',
        '',
      )}`;
    if (fieldName.includes('environment_variable.'))
      return `Environment Variable: ${fieldName.replace('environment_variable.', '')}`;
    if (fieldName.includes('CC::')) return `Collection Constant: ${fieldName.split('CC::')[1]}`;
    if (fieldName.includes('PC::')) return `Project Constant: ${fieldName.split('PC::')[1]}`;
    if (fieldName.includes('RF::')) return `Reference Field: ${fieldName.replace('RF::', '')}`;
    return '';
  };

  getCollectionFieldTitle = (field) => {
    const { fields } = this.props.collection;
    if (Array.isArray(field)) {
      let fieldTitles = [];
      field.forEach((fieldName) => {
        if (fieldsPrefixForDF.some((str) => fieldName.includes(str))) {
          fieldName = this.getFieldNameFromConstant(fieldName);
          fieldTitles.push(fieldName);
        } else {
          const fieldObj = fields.find((e) => e.fieldName === fieldName);
          if (fieldObj) {
            fieldTitles.push(fieldObj.fieldTitle.en);
          }
        }
      });

      if (fieldTitles.length === 1) {
        return fieldTitles[0];
      } else {
        return fieldTitles.join(', ');
      }
    } else {
      if (fieldsPrefixForDF.some((str) => field.includes(str))) {
        return this.getFieldNameFromConstant(field);
      } else {
        const fieldObj = fields.find((e) => e.fieldName === field);
        return fieldObj ? fieldObj.fieldTitle.en : '';
      }
    }
  };

  handleDelete = () => {
    const { utility, projectId, collection, version, actions, commonActions } = this.props;
    const preConfirm = () => {
      actions.deleteUitilityFunction({
        projectId,
        collectionUuid: collection.uuid,
        utilityId: utility._id,
        version,
      });
      commonActions.trackCollectionChange({ uuid: collection.uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showEditUtility = () => {
    const { utility, projectId, collection, showUtilityDeleteLoader, deleteFlag, isReadOnly } =
      this.props;
    const { isEditUtility } = this.state;
    if (isEditUtility) {
      return (
        <EditDerivedField
          utility={utility}
          projectId={projectId}
          collection={collection}
          updateUtility={this.updateUtility}
          disableUpdateUtility={this.disableUpdateUtility}
        />
      );
    } else {
      return (
        <Fragment>
          <div className="col-12">
            <p>
              <b>Function Name: </b> {utility.name}
            </p>

            <p>
              <b>Function Type: </b> {labelForFunctionMethod(utility.functionType)}
            </p>

            <p>
              {utility.args.map((arg) => (
                <Fragment key={arg.key}>
                  {(arg.name === 'numbers' ||
                    arg.name === 'datentime' ||
                    arg.name === 'datentime1' ||
                    arg.name === 'datentime2') && (
                    <p>
                      <b>Subjects:</b>{' '}
                      {arg.key === 'CURRENT_DATE_TIME'
                        ? 'Current Date & Time'
                        : this.getCollectionFieldTitle(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'subject' && (
                    <p>
                      <b>Subject:</b> {this.getCollectionFieldTitle(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'noSplitopt' && (
                    <p>
                      <b>No split opt:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'numbers1' && (
                    <p>
                      <b>Subject 1: </b>
                      {this.getCollectionFieldTitle(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'numbers2' && (
                    <p>
                      <b>Subject 2:</b> {this.getCollectionFieldTitle(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'restToLower' && (
                    <p>
                      <b>Rest to Lower:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'whitespace' && (
                    <p>
                      <b>Whitespace:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'type' && (
                    <p>
                      <b>Type:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'length' && (
                    <p>
                      <b>length:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'endopt' && (
                    <p>
                      <b>End Option:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'currency' && (
                    <p>
                      <b>Currency:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'position' && (
                    <p>
                      <b>Position:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'maxFraction' && (
                    <p>
                      <b>Fraction:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'condition' && (
                    <p>
                      <b>Condition:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'refField' && (
                    <p>
                      <b>Reference Field:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'match' && (
                    <p>
                      <b>Match:</b> {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'index' && (
                    <p>
                      <b>Index:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'positionOfRecords' && (
                    <p>
                      <b>Position:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'numberOfRecords' && (
                    <p>
                      <b>Number of Records:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'elementToRender' && (
                    <p>
                      <b>Element to Render:</b> {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'textFields' && (
                    <p>
                      <b>Subjects: </b>
                      {this.getCollectionFieldTitle(arg.key)}{' '}
                    </p>
                  )}
                  {arg.name === 'startString' && (
                    <p>
                      <b>Start string: </b>
                      {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'endString' && (
                    <p>
                      <b>End string: </b>
                      {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'separator' && (
                    <p>
                      <b>Separator : </b>
                      {arg.key}{' '}
                    </p>
                  )}
                  {arg.name === 'expression' ? (
                    <p>
                      <b>Expression:</b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'formatType' ? (
                    <p>
                      <b>Format Type:</b>
                      {arg.key}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'indexNum' ? (
                    <p>
                      <b>Value of N: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'field' ? (
                    <p>
                      <b>Field: </b>
                      {snakeCaseToTitleCase(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'tableStyle' ? (
                    <p>
                      <b>Table Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}

                  {arg.name === 'theadStyle' ? (
                    <p>
                      <b>Table Head (thead) Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'tbodyStyle' ? (
                    <p>
                      <b>Table Body (tbody) Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'trStyle' ? (
                    <p>
                      <b>Table Row (tr) Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'thStyle' ? (
                    <p>
                      <b>Table head Cell (th) Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'tdStyle' ? (
                    <p>
                      <b>Table Data Cell (td) Style: </b>
                      {expressionToString(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'tableRefernceFields' ? (
                    <p>
                      <b>tableRefernceFields: </b>
                      {TABLE_FORMAT(arg.key)}
                    </p>
                  ) : (
                    ''
                  )}

                  {arg.name === 'unitToAdd' ? (
                    <p>
                      <b>Value to add to date: </b>
                      {arg.key}{' '}
                    </p>
                  ) : (
                    ''
                  )}
                  {arg.name === 'unitTypeToAdd' ? (
                    <p>
                      <b>Value Type to Add: </b>
                      {snakeCaseToTitleCase(arg.key)}{' '}
                    </p>
                  ) : (
                    ''
                  )}
                </Fragment>
              ))}
            </p>
          </div>
          <div className="col-12 text-right pb-2">
            <button
              type="button"
              className="btn btn-theme-delete mr-1"
              style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
              onClick={deleteFlag && !isReadOnly ? this.handleDelete : undefined}
              disabled={isReadOnly}
            >
              <i className="wb webconnect-trash-regular"></i> Delete
              {deleteFlag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
              <CustomLoader loading={showUtilityDeleteLoader} />
            </button>
          </div>
        </Fragment>
      );
    }
  };
  render() {
    return <div className="row">{this.showEditUtility()}</div>;
  }
}
